import { createClient } from '@supabase/supabase-js';

// Vue CLI uses VUE_APP_ prefix for environment variables
const supabaseUrl = process.env.VUE_APP_SUPABASE_URL || 'https://mmvwylsqsgnaetlldqjp.supabase.co';
const supabaseAnonKey = process.env.VUE_APP_SUPABASE_API_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1tdnd5bHNxc2duYWV0bGxkcWpwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM1NDY5MDEsImV4cCI6MjA3OTEyMjkwMX0.xO431vCaaUWTplKKG5PAI-M5lP30AiPWRdgAzFQeZb0';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Export OpenAI API key for use in other components
export const openaiApiKey = process.env.VUE_APP_OPENAI_API_KEY || '';

